module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_5.e263d4fb.mp3";